import { Dispatch, Action } from 'redux';
import * as uuidv4 from 'uuid/v4';
import { pasteImage } from '../drawing/actions/DrawingAction';
import { moveToPage } from '../actions/PageAction';

export type ImageMode = 'fill' | 'handwriting';

export interface ImagePastingTestParams {
  dispatch: Dispatch<Action>;
  numOfPages: number;
  count: number;
  width: number;
  height: number;
  mode: ImageMode;
}

const r = () => Math.floor(Math.random() * 256);
const rndColor = () => `rgb(${r()}, ${r()}, ${r()})`;
const rnd = (n: number) => Math.floor(Math.random() * n);

const createCanvas = (w: number, h: number) => {
  const canvas = document.createElement('canvas');
  canvas.style.width = `${w}px`;
  canvas.style.height = `${h}px`;
  canvas.setAttribute('width', `${w}`);
  canvas.setAttribute('height', `${h}`);

  return canvas;
};

const imagePastingTest = (params: ImagePastingTestParams) => {
  const { dispatch, numOfPages, count, width, height, mode } = params;

  const generateHandwritingImage = () => {
    const canvas = createCanvas(width, height);
    const ctx = canvas.getContext('2d');

    if (ctx == null) {
      return canvas;
    }

    ctx.strokeStyle = rndColor();
    ctx.lineWidth = 30;

    ctx.moveTo(rnd(width), rnd(height));
    ctx.beginPath();
    for (let i = 0; i < (rnd(3) + 1); i += 1) {
      ctx.bezierCurveTo(
        rnd(width), rnd(height),
        rnd(width), rnd(height),
        rnd(width), rnd(height),
      );
    }
    ctx.stroke();

    return canvas;
  };

  const generateFilledImage = () => {
    const canvas = createCanvas(width, height);
    const ctx = canvas.getContext('2d');

    if (ctx == null) {
      return canvas;
    }

    const gradient = ctx.createLinearGradient(0, 0, width, height);
    for (let i = 0; i <= 1; i += 1 / 20) {
      gradient.addColorStop(i, rndColor());
    }
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);

    return canvas;
  };

  (async () => {
    for (let i = 0; i < numOfPages; i += 2) {
      moveToPage(0, i, dispatch);
      await new Promise(resolve => requestAnimationFrame(resolve));

      for (let j = 0; j < count; j += 1) {
        const picture = mode === 'fill' ? generateFilledImage() : generateHandwritingImage();
        const id = uuidv4();

        dispatch(pasteImage(
          { id , picture },
          rnd(1696) - (width / 2),
          rnd(1200) - (height / 2),
          0.5,
        ));
        await new Promise(resolve => requestAnimationFrame(resolve));
      }
    }
  })();
};

export default imagePastingTest;
